import { Theme } from '@mui/material';

export const getInputLabelStyles = (theme: Theme) => ({
  transform: `${theme.custom.inputLabels} !important`,
  fontSize: '0.875rem !important',
  color: 'colors.lightGrey',
});
